// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"7418":"settings-apps-view","8351":"settings-users"}[chunkId] + "-" + chunkId + ".js?v=" + {"7418":"a031ad73a287df0c9dfd","8351":"80297d9690279da1077b"}[chunkId] + "";
};